import React from 'react'

function ManageNotificationLayer() {
  return (
    <div>

    </div>
  )
}

export default ManageNotificationLayer
